import {
  COST_CHANGE_INSIGHTS_ITEM_OPTIONS,
  COST_CHANGE_INSIGHTS_VIEW_BY_OPTIONS,
  COST_CHANGE_INSIGHTS_LOCATION_OPTIONS,
  COST_CHANGE_INSIGHTS_TIMEFRAME_OPTIONS,
  COST_CHANGE_INSIGHTS_MISC_OPTIONS,
  COST_CHANGE_INSIGHTS_SUBMENU_DETAILS_MAP,
} from '../../globalConfig/constants'
import { processList } from '../../services/helperFunctions'
import isEqual from 'lodash/isEqual'
import isEmpty from 'lodash/isEmpty'

export const constructInitialValueStates = (defaultGlobalStateFilters) => {
  const returnObject = {}
  Object.values(COST_CHANGE_INSIGHTS_ITEM_OPTIONS).forEach((field) => {
    returnObject[field.variableName] =
      field.filterType === 'AUTOCOMPLETE' ? [] : ''
  })
  Object.values(COST_CHANGE_INSIGHTS_TIMEFRAME_OPTIONS).forEach((field) => {
    returnObject[field.variableName] =
      defaultGlobalStateFilters?.[field.variableName] &&
      isEmpty(defaultGlobalStateFilters?.[field.variableName])
        ? defaultGlobalStateFilters?.[field.variableName]
        : {}
  })
  Object.values(COST_CHANGE_INSIGHTS_MISC_OPTIONS).forEach((field) => {
    returnObject[field.variableName] =
      field.filterType === 'AUTOCOMPLETE'
        ? defaultGlobalStateFilters?.[field.variableName]?.length
          ? defaultGlobalStateFilters?.[field.variableName].map((str) => ({
              id: str,
              value: str,
              label: str,
            }))
          : []
        : defaultGlobalStateFilters?.[field.variableName]
          ? defaultGlobalStateFilters?.[field.variableName]
          : ''
  })
  Object.values(COST_CHANGE_INSIGHTS_LOCATION_OPTIONS).forEach((field) => {
    returnObject[field.variableName] =
      field.filterType === 'AUTOCOMPLETE'
        ? defaultGlobalStateFilters?.[field.variableName]?.length
          ? defaultGlobalStateFilters?.[field.variableName].map((str) => ({
              id: str,
              value: str,
              label: str,
            }))
          : []
        : defaultGlobalStateFilters?.[field.variableName]
          ? defaultGlobalStateFilters?.[field.variableName]
          : ''
  })
  returnObject[
    COST_CHANGE_INSIGHTS_LOCATION_OPTIONS.COST_LOCATION_GROUP_TYPE.variableName
  ] = defaultGlobalStateFilters?.[
    COST_CHANGE_INSIGHTS_LOCATION_OPTIONS.COST_LOCATION_GROUP_TYPE.variableName
  ]
    ? defaultGlobalStateFilters?.[
        COST_CHANGE_INSIGHTS_LOCATION_OPTIONS.COST_LOCATION_GROUP_TYPE
          .variableName
      ]
    : null

  return returnObject
}

export const getSelectionsAndErrorsFromValueStates = (valueStates) => {
  const returnObject = {}
  const unrecognizedValues = {}
  Object.values(COST_CHANGE_INSIGHTS_ITEM_OPTIONS).forEach((field) => {
    if (valueStates[field.variableName]?.length) {
      if (typeof valueStates[field.variableName] === 'string') {
        const processListResults = processList(
          valueStates[field.variableName],
          field?.regexPattern,
        )
        returnObject[field.variableName] = processListResults?.recognizedValues
        if (processListResults?.unrecognizedValues.length) {
          unrecognizedValues[field.keyName] =
            processListResults?.unrecognizedValues
        }
      } else {
        if (field.keyName === 'DEPARTMENT_CLASS') {
          returnObject[field.variableName] = valueStates[
            field.variableName
          ].map((element) => {
            return `${
              valueStates[
                COST_CHANGE_INSIGHTS_ITEM_OPTIONS.DEPARTMENTS.variableName
              ][0].value
            }-${element.value}`
          })
        } else {
          returnObject[field.variableName] = valueStates[
            field.variableName
          ].map((element) => {
            return element.value
          })
        }
      }
    }
  })
  return {
    selections: returnObject,
    errors: unrecognizedValues,
  }
}

export const isItemAddCriteriaButtonDisabled = (valueStates) => {
  let hasAnInput = false
  Object.values(COST_CHANGE_INSIGHTS_ITEM_OPTIONS).forEach((field) => {
    if (valueStates[field.variableName]?.length > 0) {
      hasAnInput = true
    }
  })
  return !hasAnInput
}

export const constructViewByLevelAutocompleteOptions = () => {
  const returnOptions = [{ id: 'ALL', value: null, label: 'All Locations' }]
  Object.values(COST_CHANGE_INSIGHTS_VIEW_BY_OPTIONS).forEach((field) => {
    returnOptions.push({
      id: field.variableName,
      value: field.variableName,
      label: field.label,
    })
  })
  return returnOptions
}

export const convertObjectToSearchParams = (searchCriteriaObj) => {
  const allFieldsByVariableNames = Object?.values({
    ...COST_CHANGE_INSIGHTS_ITEM_OPTIONS,
    ...COST_CHANGE_INSIGHTS_LOCATION_OPTIONS,
    ...COST_CHANGE_INSIGHTS_TIMEFRAME_OPTIONS,
    ...COST_CHANGE_INSIGHTS_MISC_OPTIONS,
  }).reduce((self, header) => ({ ...self, [header.variableName]: header }), {})
  const newSearchObj = { ...searchCriteriaObj }
  const returnObj = {}
  Object.keys(newSearchObj).forEach((key) => {
    if (
      newSearchObj[key] !== null &&
      newSearchObj[key] !== '' &&
      !isEqual([], newSearchObj[key]) &&
      allFieldsByVariableNames[key]?.keyName
    ) {
      if (
        Object.values(COST_CHANGE_INSIGHTS_TIMEFRAME_OPTIONS).some(
          (field) => field.variableName === key,
        )
      ) {
        returnObj[allFieldsByVariableNames[key].keyName] =
          `${newSearchObj[key]?.startDate}-${newSearchObj[key]?.endDate}`
      } else {
        returnObj[allFieldsByVariableNames[key].keyName] = newSearchObj[key]
      }
    }
  })
  return returnObj
}

export const isResetSelectionsButtonDisabled = (
  globalStateSearchCriteria,
  pageState,
  pathname,
) => {
  const hasDefaultedSelections = isEqual(
    globalStateSearchCriteria,
    COST_CHANGE_INSIGHTS_SUBMENU_DETAILS_MAP?.[
      pathname
    ].GET_DEFAULT_SELECTIONS(),
  )

  const hasNoResults = !pageState?.costChangeItems

  return hasDefaultedSelections && hasNoResults
}

export const isSearchButtonDisabled = (valueStates) => {
  const viewByLevelValue =
    valueStates[
      COST_CHANGE_INSIGHTS_LOCATION_OPTIONS.COST_LOCATION_GROUP_TYPE
        .variableName
    ]
  return Boolean(
    viewByLevelValue &&
      viewByLevelValue !==
        COST_CHANGE_INSIGHTS_VIEW_BY_OPTIONS.CHAIN.variableName &&
      !valueStates[
        COST_CHANGE_INSIGHTS_LOCATION_OPTIONS.COST_LOCATION_GROUP_VALUES
          .variableName
      ].length,
  )
}

export const isViewByValueInputDisabled = (valueStates) => {
  return (
    COST_CHANGE_INSIGHTS_VIEW_BY_OPTIONS[
      valueStates[
        COST_CHANGE_INSIGHTS_LOCATION_OPTIONS.COST_LOCATION_GROUP_TYPE
          .variableName
      ]
    ]?.filterType !== 'AUTOCOMPLETE'
  )
}

export const stripItemHubPath = (pathname) => {
  if (pathname.substring(0, 5) === '/cost') {
    return pathname.substring(5)
  } else {
    return pathname
  }
}
